export class UserUnauthenticatedException extends Error {}
